import React from 'react'
import formatMenuItems from '../../functions/formatMenuItems'
import MenuItemWithSubItems from './MenuItemWithSubItems'
import MenuItemSingle from './MenuItemSingle'
import Translation from '../Translation/cont/Translation'

const WebsiteMenu = ({menuItems, menuItemsOrder, pages, routes, pagesOrder, cinemas, currentCinemaId}) => {

    if(_.isEmpty(menuItems) || _.isEmpty(pages)) {
        return ''
    }
    const currentCinema = cinemas[currentCinemaId]
    const menuItemsArray = []
    const pageIdsInMenu = []
    const homePages = []
    const overviewPages = []

    if(routes) {
        const {frontpage, program_overview} = routes
        
        if(frontpage) {
            _.keys(frontpage).map(key => {
                const page = frontpage[key]
                
                if(page && page.uri) {
                    homePages.push(page.uri)
                }
            })
        }
        if(program_overview) {
            _.keys(program_overview).map(key => {
                const page = program_overview[key]
                
                if(page && page.uri) {
                    overviewPages.push(page.uri)
                }
            })
        }
    } 
    
    menuItemsOrder.map(itemId => {
        const menuItem = menuItems[itemId]
        menuItemsArray.push(menuItem)
        pageIdsInMenu.push(parseInt(menuItem.object_id))
    })
    
    const pagesIdsNotInMenu = _.difference( pagesOrder, pageIdsInMenu)
    const formatedMenuItems = formatMenuItems(menuItemsArray)
    
    const itemList = formatedMenuItems.map((menuItem, index) => (
        <MenuItemWithSubItems 
            key={index}
            menuItem={menuItem}
            currentCinema={currentCinema}
            homePages={homePages}
            overviewPages={overviewPages}
            pages={pages}
        />
    ))
        
    const pagesNotInMenuItemList = pagesIdsNotInMenu.map((pageId, index) => {
        const page = pages[pageId]
        const { post_title, elementorlink, permalink } = page
        const isHomeOrOverview = _.contains(homePages, permalink) || _.contains(overviewPages, permalink) ? true : false
        const showElementorlink = isHomeOrOverview ? null : elementorlink

        return (
            <li key={index} className="item-list gap-30">
                <MenuItemSingle 
                    linktext={post_title} 
                    link={showElementorlink} 
                />
            </li>
        )
    })

    return (
        <div className="menu-list-container">
            <div className="menu-list">
                <div className='text-periode-date accordion-headline title-large-light'>
                    <Translation id="website_navigation">Navigation</Translation>
                </div>

                <ul className={'grid-container'}>
                    {itemList}
                </ul>
            </div>

            {pagesIdsNotInMenu.length > 0 && 
                <div className="menu-list">
                    <div className='text-periode-date accordion-headline title-large-light'>
                        <Translation id="website_navigation_no_item">Seiten die nicht im Menu sind"</Translation>
                    </div>

                    <ul className={'grid-container'}>
                        {pagesNotInMenuItemList}
                    </ul>
                </div>
            }

            <div className="menu-buttons">
                <a target="_blank" className="button" href="../../wp-admin/post-new.php?post_type=page">
                    <Translation id="website_add_new_page">Neue Seite hinzufügen</Translation>
                </a>

                <a target="_blank" className="button" href="../../wp-admin/nav-menus.php">
                    <Translation id="website_edit_menu">Menü bearbeiten</Translation>
                </a>
            </div>
        </div>

    )
}

export default WebsiteMenu